// BloomQuoteSection.jsx
import React from "react";
import "../../../assets/css/BloomQuoteSection.css";
import bgImage from "../../../assets/images/watercolor-paper-texture.jpg"; // Replace with your background image path

const BloomQuoteSection = () => {
  return (
    <section
      className="bloom-quote-section"
      // style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="bloom-quote-overlay">
        <h2 className="bloom-quote-main">
          Every step is guided by care, confidentiality, and a <br />
          deep respect for what you're going through.
        </h2>
        <p className="bloom-quote-sub">
          Because Bloom isn’t just about clothing. It’s about how you feel when you wear it.
        </p>
      </div>
    </section>
  );
};

export default BloomQuoteSection;
